const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "my-general-store-76674.firebaseapp.com",
  projectId: "my-general-store-76674",
  storageBucket: "my-general-store-76674.firebasestorage.app",
  messagingSenderId: "193661449819",
  appId: "1:193661449819:web:085fe021b452216a17717e",
  measurementId: "G-B0DKGL104X"
};

console.log(process.env)

export default firebaseConfig;